<template>
  <div class="rensheProfile">
    <div class="form_tips" v-if="type=='auth'">
      <p class="txt">
        应人社部门监管要求，请用户务必按照指引完成实名认证信息，如上传虚假信息，将会导致本次培训无效并由个人承担一切后果。
      </p>
    </div>
    <template v-else>
      <van-nav-bar class="page_nav" title="考试认证信息" left-arrow @click-left="back" :fixed="true" />
      <div class="placeholder_box" style="height:46PX"></div>
    </template>
    <van-form
        class="form_wrap"
        ref="validateForm"
        validate-first
        input-align="right"
        :show-error="false"
        :show-error-message="false"
        :class="{tipMarginTop:type=='auth'}"
      >
    <p class="sec_title">基础信息</p>
     <van-field
        type="text"
        :value="name"
        label="姓名"
        readonly
        v-if="name && idCardNo"
      />
      <van-field
        :value="idCardNo"
        label="身份证"
        readonly
        v-if="idCardNo"
      >
        <template #input>
          <div class="shiming_display">
            <img src="./assets/images/shiming_icon.png" class="shiming_icon" />
            <span>{{idCardNo}}</span>
          </div>
        </template>
      </van-field>
       <van-field
        required
        label="二寸免冠照"
        class="photo_wrap"
        readonly
        :rules="[{ validator: ()=>!!userInfo.headImg, message: '请上传二寸免冠照' }]"
      >
        <template #input>
          <div class="photo_box">
           <van-uploader accept="image/*" :before-read="beforeRead" :after-read="afterRead" :readonly="type=='view'">
							<div class="avtar">
								<van-loading v-if="uploadLoading" class="uploadLoading" size="20px" vertical color="#1989fa">上传中...</van-loading>
								<img :src="userInfo.headImg || require('../../../assets/images/account/userdefault2.png')" alt="" />
							</div>
						</van-uploader>
            <p class="headImg_tips" v-if="type!='view'">点击上传近期二寸免冠照</p>
          </div>
        </template>
      </van-field>
       <van-field
        clickable
        readonly
        right-icon="arrow"
        :value="userInfo.vocationTxt"
        label="职业"
        placeholder="请选择职业"
        @click="type!='view'?showVocationPicker = true:null"
      />
      <van-popup v-model="showVocationPicker" round position="bottom">
        <van-picker
          title="请选择职业"
          show-toolbar
          :default-index="activeVocationIndex"
          :columns="vocationLists"
          @cancel="showVocationPicker = false"
          @confirm="vocationOnConfirm"
        />
      </van-popup>
      <van-field
        clickable
        readonly
        right-icon="arrow"
        :value="userInfo.workTypeTxt"
        label="工种"
        placeholder="请选择工种"
        @click="type!='view'?showWorkTypePicker = true:null"
      />
      <van-popup v-model="showWorkTypePicker" round position="bottom">
        <van-picker
          title="请选择工种"
          show-toolbar
          :default-index="activeWorkTypeIndex"
          :columns="workTypeLists"
          @cancel="showWorkTypePicker = false"
          @confirm="workTypeOnConfirm"
        />
      </van-popup>
       <van-field
        clickable
        readonly
        right-icon="arrow"
        :value="userInfo.skillLevelTxt"
        label="等级"
        placeholder="请选择等级"
        @click="type!='view'?showSkillLevelPicker = true:null"
      />
      <van-popup v-model="showSkillLevelPicker" round position="bottom">
        <van-picker
          title="请选择等级"
          show-toolbar
          :default-index="activeSkillLevelIndex"
          :columns="skillLevelLists"
          @cancel="showSkillLevelPicker = false"
          @confirm="skillLevelOnConfirm"
        />
      </van-popup>
      <div class="license-box">
        <p class="sec_title sec_title1">学历证书</p>
        <van-field name="uploader" :label="type!='view'?'上传证书':''">
          <template #input>
            <div class="certificate_box">
              <template v-if="userInfo.eduCertificate.length">
                <div class="my_photo" v-for="(imgSrc,index) in userInfo.eduCertificate" :key="index">
                  <img
                    src="../../../assets/images/common/delete-icon.png"
                    alt=""
                    class="del-icon"
                    @click="delCertificateImg(index,'edu')"
                    :style="{display:type=='view'?'none':'block'}"
                  />
                  <div class="tips">
                    <img
                      :src="imgSrc"
                      class="re_uploadImg"
                    />
                  </div>
                </div>
              </template>
              
              <div class="file_box" v-if="userInfo.eduCertificate.length<5 && type!='view'">
                <div class="upload-icon">
                  <img src="../../../assets/images/common/upload-icon.png" alt="" />
                </div>
                <input
                  type="file"
                  id="photoFile"
                  class="file"
                  ref="file"
                  @change="readFile($event, 'edu')"
                  accept="image/*"
                />
              </div>
            </div>
          </template>
        </van-field>
      </div>
      <div class="license-box">
        <p class="sec_title sec_title2">原有证书</p>
        <van-field name="uploader" :label="type!='view'?'上传证书':''">
          <template #input>
            <div class="certificate_box">
              <template v-if="userInfo.originalCertificate.length">
                <div class="my_photo" v-for="(imgSrc,index) in userInfo.originalCertificate" :key="index">
                  <img
                    src="../../../assets/images/common/delete-icon.png"
                    alt=""
                    class="del-icon"
                    @click="delCertificateImg(index,'original')"
                    :style="{display:type=='view'?'none':'block'}"
                  />
                  <div class="tips">
                    <img
                      :src="imgSrc"
                      class="re_uploadImg"
                    />
                  </div>
                </div>
              </template>
              <div class="file_box" v-if="userInfo.originalCertificate.length<5 && type!='view'">
                <div class="upload-icon">
                  <img src="../../../assets/images/common/upload-icon.png" alt="" />
                  <!-- <span>上传图片</span> -->
                </div>
                <input
                  type="file"
                  id="photoFile"
                  class="file"
                  ref="file"
                  @change="readFile($event, 'original')"
                  accept="image/*"
                />
              </div>
            </div>
          </template>
        </van-field>
      </div>

    </van-form>
    <div class="bottom_fixed" v-if="type!='view'">
      <span class="btn" @click="saveUserInfo">{{type=='auth'?'下一步':'保存'}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "rensheMyProfile",
  data() {
    return {
      userUcode: "",
      name: "",
      idCardNo: "",
      type: this.$route.query.type || null,
      uploadLoading: false,
      userInfo: {
        headImg: "",
        vocation: "",
        workType: "",
        skillLevel: "",
        vocationTxt: "",
        workTypeTxt: "",
        skillLevelTxt: "",
        eduCertificate: [],
        originalCertificate: []
      },
      vocationLists: [],
      workTypeLists: [],
      skillLevelLists: [],
      showVocationPicker: false,
      showWorkTypePicker: false,
      showSkillLevelPicker: false,
      activeVocationIndex: 0,
      activeWorkTypeIndex: 0,
      activeSkillLevelIndex: 0,
      haveSavedDetailFlag: false,
      WDuserInfo: {}
    };
  },
  async created() {
    await this.getMaasVocation(null, "vocation");
    if (localStorage.getItem("WDuserInfo")) {
      this.WDuserInfo = JSON.parse(localStorage.getItem("WDuserInfo"));
      this.userUcode = this.WDuserInfo.userUcode || "";
      this.name = this.WDuserInfo.name || "";
      this.idCardNo = this.WDuserInfo.idCardNo || "";
    }
    if (this.userUcode) {
      this.getDetail();
    }
  },
  mounted() {
    if (window.history && window.history.pushState && this.type == "auth") {
      // 往历史记录里面添加一条新的当前页面的url
      history.pushState(null, null, document.URL);
      // 给 popstate 绑定一个方法 监听页面刷新
      window.addEventListener("popstate", this.back, false); //false阻止默认事件
    }
  },
  destroyed() {
    if (this.type == "auth") {
      window.removeEventListener("popstate", this.back, false); //false阻止默认事件
    }
  },
  methods: {
    back() {
      console.log("3333", this.$store.state.rsDistribution.finishAuth);
      this.haveSavedDetailFlag =
        this.WDuserInfo.idAuthStatus &&
        this.WDuserInfo.faceAuthStatus &&
        this.$store.state.rsDistribution.finishAuth;
      if (!this.haveSavedDetailFlag) {
        this.$notify({
          duration: 3000,
          type: "danger",
          message: "请先完成考试认证"
        });
        if (window.history && window.history.pushState && this.type == "auth") {
          // 往历史记录里面添加一条新的当前页面的url
          history.pushState(null, null, document.URL);
          // 给 popstate 绑定一个方法 监听页面刷新
          window.addEventListener("popstate", this.back, false); //false阻止默认事件
        }
      } else {
        this.$router.push("/saccount");
      }
    },
    getDetail() {
      this.$api.rensheDistributionExam
        .findUserAnnexByParam({ ucode: this.userUcode })
        .then(res => {
          if (res.success && res.data) {
            const rensheDistributionIsAuth =
              res.data && Array.isArray(res.data) && res.data.length > 0;
            this.$store.commit("setRsDistribution", rensheDistributionIsAuth);
            res.data.forEach(item => {
              if (item.columnMeaning == 12) {
                item.filePath
                  ? this.userInfo.eduCertificate.push(item.filePath)
                  : null;
              } else if (item.columnMeaning == 13) {
                item.filePath
                  ? this.userInfo.originalCertificate.push(item.filePath)
                  : null;
              } else if (item.columnMeaning == 14) {
                item.filePath ? this.handleVocation(item.filePath) : null;
              } else if (item.columnMeaning == 15) {
                item.filePath ? (this.userInfo.headImg = item.filePath) : null;
              }
            });
          }
        });
    },
    //处理职业工种等级
    async handleVocation(val) {
      const arr = val.split("-");
      console.log(arr);
      if (arr.length >= 4) {
        this.userInfo.vocation = arr.slice(0, 4).join("-");
        const obj1 = this.matchText(this.vocationLists, this.userInfo.vocation);
        this.userInfo.vocationTxt = obj1.text;
        this.activeVocationIndex = obj1.index;
        await this.getMaasVocation(this.userInfo.vocation, "workType");
      }
      if (arr.length >= 5) {
        this.userInfo.workType = arr.slice(0, 5).join("-");
        const obj2 = this.matchText(this.workTypeLists, this.userInfo.workType);
        this.userInfo.workTypeTxt = obj2.text;
        this.activeWorkTypeIndex = obj2.index;
        await this.getMaasVocation(this.userInfo.workType, "skillLevel");
      }
      if (arr.length >= 6) {
        this.userInfo.skillLevel = arr.slice(0, 6).join("-");
        const obj3 = this.matchText(
          this.skillLevelLists,
          this.userInfo.skillLevel
        );
        this.userInfo.skillLevelTxt = obj3.text;
        this.activeSkillLevelIndex = obj3.index;
      }
    },
    //匹配内容
    matchText(data, resVal) {
      let result = {};
      data.forEach((item, index) => {
        if (item.vocationCode == resVal) {
          result.text = item.text;
          result.index = index;
        }
      });
      return result;
    },
    async getMaasVocation(parentCode, type) {
      const params = {
        type:4,
        parentCode:parentCode || undefined
      }
      let res = await this.$api.rensheDistributionExam.getMaasVocation(params);
      if (res.success && res.data) {
        this[`${type}Lists`] = res.data.map(item => {
          return {
            vocationCode: item.vocationCode,
            text: item.vocationName
          };
        });
      }
    },
    vocationOnConfirm(value, index) {
      console.log(value, index);
      this.userInfo.vocationTxt = value.text;
      this.userInfo.vocation = this.vocationLists[index].vocationCode;
      this.showVocationPicker = false;

      this.userInfo.workTypeTxt = "";
      this.userInfo.workType = "";
      this.workTypeLists = [];
      this.userInfo.skillLevelTxt = "";
      this.userInfo.skillLevel = "";
      this.skillLevelLists = [];
      this.getMaasVocation(this.userInfo.vocation, "workType");
    },
    workTypeOnConfirm(value, index) {
      this.userInfo.workTypeTxt = value.text;
      this.userInfo.workType = this.workTypeLists[index].vocationCode;
      this.showWorkTypePicker = false;
      this.userInfo.skillLevelTxt = "";
      this.userInfo.skillLevel = "";
      this.skillLevelLists = [];
      this.getMaasVocation(this.userInfo.workType, "skillLevel");
    },
    skillLevelOnConfirm(value, index) {
      this.userInfo.skillLevelTxt = value.text;
      this.userInfo.skillLevel = this.skillLevelLists[index].vocationCode;
      this.showSkillLevelPicker = false;
    },
    saveUserInfo() {
      this.$refs.validateForm
        .validate()
        .then(() => {
          const eduCertificate = this.userInfo.eduCertificate.map(item => {
            return {
              columnMeaning: 12,
              filePath: item
            };
          });
          const originalCertificate = this.userInfo.originalCertificate.map(
            item => {
              return {
                columnMeaning: 13,
                filePath: item
              };
            }
          );
          this.$api.rensheDistributionExam
            .saveUserAnnexByParam({
              ucode: this.userUcode,
              annexVoList: [
                //9来源机构 12 学员学历证书 13 学员资格证书 14学员职业工种 15二寸照
                ...eduCertificate,
                ...originalCertificate,
                {
                  columnMeaning: 14,
                  filePath:
                    this.userInfo.skillLevel ||
                    this.userInfo.workType ||
                    this.userInfo.vocation
                },
                {
                  columnMeaning: 15,
                  filePath: this.userInfo.headImg
                }
              ]
            })
            .then(res => {
              if (res.success) {
                this.$store.commit("setRsDistribution", true);
                if (this.type == "auth") {
                  //下一步检测是否实名，未实名去实名认证
                  const { idAuthStatus, faceAuthStatus } = this.WDuserInfo;
                  if (!idAuthStatus || !faceAuthStatus) {
                    this.$router.push("/idcard");
                  } else {
                    this.$router.push("/finishExamAuth");
                  }
                } else {
                  //编辑保存
                  this.$router.push("/saccount");
                }
              }
            });
        })
        .catch(error => {
          console.log(error);
          this.$toast({
            message: error[0].message,
            className: "errorTY"
          });
        });
    },
    beforeRead(file) {
      this.uploadLoading = true;
      if (file.type.indexOf("image") === -1) {
        this.$notify({
          duration: 2000,
          type: "danger",
          message: "请上传正确格式的图片"
        });
        this.uploadLoading = false;
        return false;
      }
      return true;
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      let formData = new FormData();
      formData.append("file", file.file);
      this.$api.user
        .upload(formData)
        .then(async res => {
          if (res.code == 0) {
            file.status = "";
            file.message = "";
            this.uploadLoading = false;
            this.userInfo.headImg = res.data;
          }
        })
        .catch(err => {
          file.status = "failed";
          file.message = "上传失败";
          this.uploadLoading = false;
        });
    },
    // 上传图片
    readFile(e, type) {
      let file = e.target.files[0];
      let formData = new FormData();
      formData.append("file", file);
      if (file.size / 1024 / 1024 > 10) {
        this.$notify({ type: "warning", message: "上传图片大小不超过10M" });
        return;
      }
      this.$api.user.upload(formData).then(res => {
        let attrName = `${type}Certificate`;
        if (this.userInfo[attrName].length < 5) {
          this.userInfo[attrName].push(res.data);
          return;
        }
        this.$toast.fail("最多上传5张图片");
      });
    },
    // 删除图片
    delCertificateImg(index, type) {
      let attrName = `${type}Certificate`;
      this.userInfo[attrName].splice(index, 1);
    }
  }
};
</script>

<style scoped lang="stylus">
.rensheProfile {
  min-height: 100vh;
  background: #fff;
  overflow: auto;

  .form_tips {
    position: fixed;
    z-index: 10;
    top: 0;
    left: 0;
    right: 0;
    height: 150px;
    background-color: #fff;

    .txt {
      width: 100%;
      height: 100%;
      font-size: 26px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FF7F00;
      line-height: 37px;
      background-color: rgba(255, 128, 0, 0.2);
      display: flex;
      align-items: center;
      padding: 0 32px;
      box-sizing: border-box;
    }
  }

  .page_nav {
    position: fixed;
  }

  .form_wrap {
    padding: 40px 0 152px;
    box-sizing: border-box;

    &.tipMarginTop {
      margin-top: 150px;
    }

    /deep/.van-cell {
      display: flex;
      align-items: center;
      min-height: 59px;
    }

    .shiming_display {
      display: flex;
      align-items: center;
    }

    .shiming_icon {
      width: 74px;
      height: 32px;
      margin-right: 7px;
    }
  }

  .sec_title {
    font-size: 36px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 50px;
    padding: 0 16PX;

    &.sec_title1 {
      margin-top: 48px;
      margin-bottom: 10px;
    }

    &.sec_title2 {
      margin-top: 8px;
      margin-bottom: 10px;
    }
  }

  .photo_wrap {
    /deep/ .van-field__control {
      justify-content: flex-start;
    }
  }

  .photo_box {
    text-align: center;

    .headImg_tips {
      font-size: 24px;
      color: #3760FF;
      line-height: 33px;
      margin-top: 24px;
    }

    .avtar {
      position: relative;
      width: 200px;
      height: 260px;
      margin: 0 auto;
      border-radius: 16px;
      // margin-bottom :36px;
      overflow: hidden;

      .uploadLoading {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background-color: rgba(255, 255, 255, 0.6);
        border-radius: 50%;
        text-align: center;

        /deep/ .van-loading__spinner {
          margin-top: 25px;
        }
      }

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  /* 上传文件样式 */
  .license-box {
    /deep/.van-cell {
      flex-direction: column;
      align-items: flex-start;

      .van-field__label {
        margin-bottom: 10px;
      }
    }
  }

  .file_box {
    position: relative;
    width: 215px;
    height: 215px;

    .upload-icon {
      width: 100%;
      height: 100%;
      border-radius: 14px;
      border: 1px solid #EAEAEA;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 44px;
        height: 44px;
      }
    }

    input {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
    }
  }

  .certificate_box {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 690px;
    // padding-bottom: 32px;
    box-sizing: border-box;

    .my_photo {
      margin-right: 20px;
      margin-bottom: 20px;
      width: 215px;
      height: 215px;
      position: relative;

      &:nth-child(3) {
        margin-right: 0;
      }

      .del-icon {
        width: 36px;
        height: 36px;
        position: absolute;
        top: 0;
        right: 0;
        transform: translate(30%, -30%);
      }

      .tips {
        width: 100%;
        height: 100%;

        img {
          width: 100%;
          height: 100%;
          border-radius: 14px;
        }
      }
    }
  }

  .bottom_fixed {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    width: 100%;
    height: 104px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    box-shadow: 0px -2px 7px 0px rgba(0, 0, 0, 0.06);

    .btn {
      width: 686px;
      height: 80px;
      background: #3760FF;
      border-radius: 40px;
      font-size: 30px;
      color: #FFFFFF;
      line-height: 80px;
      text-align: center;
    }
  }
}
</style>
